import React, { useState, useEffect } from "react";

import maintainUtm from "../../services/maintainUtm";

import IconReceita from "../../assets/icons/iconReceita";
import IconProdutor from '../../assets/icons/iconProdutor';
import whatsapp from '../../assets/icons/icon-whatsapp-gray.png'
import IconHomeGray from "../../assets/icons/icon-home-gray.png";
import IconHomeGreen from "../../assets/icons/icon-home-green.png";
import IconClockGray from "../../assets/icons/icon-clock-gray.png";
import IconClockGreen from "../../assets/icons/icon-clock-green.png";

import * as S from "./styles";
import { theme } from "../../styles/theme";
import { Minimo } from "../../styles/stylesTypography";

const NavbarMobile = ({ ...props }) => {
    const [pathname] = useState(window.location.pathname);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        const handler = (e) => setHidden(e.detail.open);
        window.addEventListener("modal-calendar-toggle", handler);
        return () => window.removeEventListener("modal-calendar-toggle", handler);
    }, []);

    if (hidden) return null;

    return (
        <S.Container>
            <S.Wrapper>
                <S.ButtonLink active={pathname === "/"}>
                    <S.Link href={pathname === "/" ? null :  `/${maintainUtm()}`}>
                        <img src={pathname === "/" ? IconHomeGreen : IconHomeGray} alt="Home" />
                    </S.Link>

                    <Minimo color={pathname === "/" ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_2}>Início</Minimo>
                </S.ButtonLink>

                <S.ButtonLink active={pathname === "/produtores"}>
                    <S.Link href={pathname === "/produtores" ? null : `/produtores${maintainUtm()}`} active={pathname === "/produtores"}>
                        <IconProdutor />
                    </S.Link>

                    <Minimo color={pathname === "/produtores" ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_2}>
                        Produtores
                    </Minimo>
                </S.ButtonLink>

                <S.ButtonLink active={true}>
                    <S.Link href={pathname === "/receitas/add" || pathname === "/receitas/addlote" ? null : `/receitas/add`} active={true}>
                        <IconReceita />
                    </S.Link>

                    <Minimo color={pathname === "/receitas/add" || pathname === "/receitas/addlote" ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_2}>
                        Receita
                    </Minimo>
                </S.ButtonLink>

                <S.ButtonLink active={pathname === "/historico"}>
                    <S.Link href={pathname === "/historico" ? null : `/historico${maintainUtm()}`} active={pathname === "/historico"}>
                        <img src={pathname === "/historico" ? IconClockGreen : IconClockGray} alt="Hístórico" />
                    </S.Link>

                    <Minimo color={pathname === "/historico" ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_2}>
                        Histórico
                    </Minimo>
                </S.ButtonLink>

                <S.ButtonLink>
                    <S.Link href={`https://wa.me/5515981657739?text=Olá, vamos conversar?`} target="_blank">
                        <img src={whatsapp} alt="whatsapp" />
                    </S.Link>

                    <Minimo color={theme.colors.gray.Cinza_2}>
                        Suporte
                    </Minimo>
                </S.ButtonLink>
            </S.Wrapper>
        </S.Container>
    );
};

export default NavbarMobile;
